<div class="glxy-file-progress-indicator">
  <mat-icon *ngIf="status === FileUploadStatus.Queued" class="status-icon"> attach_file </mat-icon>
  <mat-icon *ngIf="status === FileUploadStatus.Fail" class="fail-icon status-icon"> warning </mat-icon>
  <mat-icon *ngIf="status === FileUploadStatus.Success" class="success-icon status-icon"> done </mat-icon>
  <mat-spinner *ngIf="status === FileUploadStatus.InProgress" [diameter]="20"></mat-spinner>
</div>
